export const DeviceTypeEnum = {
    All: 0,
    Desktop: 1,
    Mobile: 2,
    Wap: 3,
    LiteBet: 4,
    MobileAndroid: 5,
    MobileIOS: 6

}

export const MobilePlatform = {
    All: 0,
    IOSApp: 1,
    AndroidApp: 2,
    IOSWeb: 4,
    AndroidWeb: 8
}

export const HeaderDeviceTypeEnum = {
    All: 1,
    Mobile: 2,
    Desktop: 3
}

export const MobileAppsDeviceTypeEnum = {
    All: 1,
    Mobile: 2,
    Desktop: 3
}



Object.freeze(DeviceTypeEnum);

export default DeviceTypeEnum;